// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___xCWoq {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.style__welcome___ggguc {
   font-size: 32px;
}

.style__text___W6AAZ {
    margin-top: 12px;
    font-size: 18px;
}

.style__sticknet___qkzif {
    font-family: 'Sirin Stencil', sans-serif;
}

.style__premium___ZyU5r {
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/client/SubCancelledScreen/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;GACG,eAAe;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.welcome {\n   font-size: 32px;\n}\n\n.text {\n    margin-top: 12px;\n    font-size: 18px;\n}\n\n.sticknet {\n    font-family: 'Sirin Stencil', sans-serif;\n}\n\n.premium {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___xCWoq`,
	"welcome": `style__welcome___ggguc`,
	"text": `style__text___W6AAZ`,
	"sticknet": `style__sticknet___qkzif`,
	"premium": `style__premium___ZyU5r`
};
export default ___CSS_LOADER_EXPORT___;
